import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../lib/api';
import { useProductScope } from '../context/ProductScopeContext';
import { copy, formatPlan } from '../lib/copy';
import { formatNumber, formatRub } from '../lib/utils';
import { ErrorState, LoadingState, PageHeader } from '../components/ui';

export function PlansPage() {
  const scope = useProductScope();
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['plans', scope],
    queryFn: () =>
      scope === 'studio'
        ? adminApi.studioPlans()
        : scope === 'app'
          ? adminApi.appPlans()
          : Promise.all([adminApi.appPlans(), adminApi.studioPlans()]).then(([app, studio]) => ({
              items: [...app.items, ...studio.items],
            })),
  });

  return (
    <div>
      <PageHeader title={copy.plansPage.title} description={copy.plansPage.description} />
      {isLoading ? <LoadingState /> : null}
      {isError ? <ErrorState message={copy.errors.loadPlans} onRetry={() => refetch()} /> : null}
      {data ? (
        <div className="ops-card overflow-hidden p-0">
          <div className="overflow-x-auto">
            <table className="ops-table">
              <thead>
                <tr>
                  <th>{copy.plansPage.id}</th>
                  <th>Продукт</th>
                  <th>{copy.plansPage.name}</th>
                  <th>{copy.plansPage.lineage}</th>
                  <th>{copy.plansPage.price}</th>
                  <th>{copy.plansPage.credits}</th>
                  <th>{copy.plansPage.fairUse}</th>
                  <th>{copy.plansPage.premiumCredits}</th>
                </tr>
              </thead>
              <tbody>
                {data.items.map((plan) => (
                  <tr key={plan.product_plan_id}>
                    <td className="font-mono text-xs">{plan.code}</td>
                    <td>{plan.product_code}</td>
                    <td>{formatPlan(plan.code)}</td>
                    <td>
                      {plan.lineage === 'unlimited'
                        ? copy.plansPage.lineageUnlimited
                        : copy.plansPage.lineageCredits}
                    </td>
                    <td>{formatRub(plan.price_rub)}</td>
                    <td>{formatNumber(plan.included_credits)}</td>
                    <td>{formatNumber(plan.fair_use_limit)}</td>
                    <td>{formatNumber(plan.included_premium_credits)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : null}
    </div>
  );
}
